const UPDATE_STORE_LOCATOR = 'UPDATE_STORE_LOCATOR'
const UPDATE_ALTERNATIVE_STORE = 'UPDATE_ALTERNATIVE_STORE'
const UPDATE_CIS_COOKIE_STATUS = 'UPDATE_CIS_COOKIE_STATUS'

export { UPDATE_STORE_LOCATOR, UPDATE_ALTERNATIVE_STORE, UPDATE_CIS_COOKIE_STATUS }
